import RoleMenu from "./role-menu.jsx";

export default RoleMenu;